var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header" },
    [
      _c(
        "div",
        {
          staticClass: "system fixedHead",
          class: {
            activeClass: _vm.$store.state.headerBg,
            addPadding: _vm.fixedModule
          },
          attrs: { id: "barHeight" }
        },
        [
          _c(
            "div",
            { staticClass: "systemItem", attrs: { id: "setHeight" } },
            [
              !this.$route.meta.notReturnBtn
                ? [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$store.state.headerBg,
                          expression: "$store.state.headerBg"
                        }
                      ],
                      staticClass: "leftImg",
                      attrs: {
                        src: require("@assets/images/fundDetail/goBack.png")
                      },
                      on: { click: _vm.onClickLeft }
                    }),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.$store.state.headerBg &&
                            _vm.$route.path !=
                              "/personalProcess/uploadMaterial" &&
                            _vm.$route.path != "/personalConfirmation" &&
                            _vm.$route.path != "/orgConfirmation",
                          expression:
                            "\n          !$store.state.headerBg &&\n          $route.path != '/personalProcess/uploadMaterial' &&\n          $route.path != '/personalConfirmation' &&\n          $route.path != '/orgConfirmation'\n        "
                        }
                      ],
                      staticClass: "leftImg",
                      attrs: {
                        src: require("@assets/images/header/backIcon.png")
                      },
                      on: { click: _vm.onClickLeft }
                    })
                  ]
                : _vm._e(),
              _vm.urlReturn === this.$route.path ||
              this.$route.path == "/riskResult1"
                ? [
                    _c("img", {
                      staticClass: "leftImg",
                      attrs: {
                        src: require("@assets/images/header/backIcon.png")
                      },
                      on: { click: _vm.returnNativeFun }
                    })
                  ]
                : _vm.showCurrent
                ? [
                    _c("img", {
                      staticClass: "leftImg",
                      attrs: {
                        src: require("@assets/images/header/backIcon.png")
                      },
                      on: { click: _vm.returnNativeFun }
                    })
                  ]
                : _vm.returnH === "1"
                ? [
                    _c("img", {
                      staticClass: "leftImg",
                      attrs: {
                        src: require("@assets/images/header/backIcon.png")
                      },
                      on: {
                        click: function($event) {
                          return _vm.returnDetail(-1)
                        }
                      }
                    })
                  ]
                : _vm._e(),
              _vm.$route.meta.singleName
                ? [
                    _c(
                      "div",
                      { staticClass: "defaultS van-multi-ellipsis--l2" },
                      [_vm._v(" " + _vm._s(_vm.customFundName) + " ")]
                    )
                  ]
                : _vm.$route.meta.repeatName
                ? [
                    _c(
                      "div",
                      { staticClass: "defaultS van-multi-ellipsis--l2" },
                      [_vm._v(" " + _vm._s(_vm.repeatNameInfo) + " ")]
                    )
                  ]
                : [
                    (!_vm.isDetail &&
                      _vm.$route.path == "/publicFundsDetail") ||
                    (!_vm.isDetail &&
                      _vm.$route.path != "/publicFundsDetail" &&
                      _vm.$route.path != "/newFundDetail") ||
                    (_vm.$route.path == "/newFundDetail" && !_vm.scrollFlag)
                      ? _c("div", { staticClass: "publicfunds-detail-box" }, [
                          (!_vm.isDetail &&
                            _vm.$route.path == "/publicFundsDetail") ||
                          (!_vm.isDetail &&
                            _vm.$route.path != "/publicFundsDetail" &&
                            _vm.$route.path != "/newFundDetail") ||
                          (_vm.$route.path == "/newFundDetail" &&
                            !_vm.scrollFlag)
                            ? _c("div", [
                                _vm._v(" " + _vm._s(_vm.title) + " "),
                                _vm.$route.path == "/publicFundsDetail" ||
                                _vm.$route.path == "/newFundDetail"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "share-news",
                                        on: {
                                          click: function($event) {
                                            return _vm.newShareEvent(
                                              _vm.$route.path ==
                                                "/newFundDetail"
                                                ? true
                                                : false
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/images/publicFundsChange/share_white.png"),
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ])
                      : _vm.$route.path == "/newFundDetail" && _vm.scrollFlag
                      ? _c("div", {}, [
                          _c("div", [
                            _c(
                              "span",
                              {
                                style: {
                                  fontSize: _vm.changeCharSize
                                    ? "14px"
                                    : "inherit"
                                }
                              },
                              [_vm._v(_vm._s(_vm.newFoundItem.fundName))]
                            ),
                            _c("span", { staticClass: "stock-code" }, [
                              _vm._v(_vm._s(_vm.newFoundItem.fundCode))
                            ])
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "share-news-scroll",
                              on: {
                                click: function($event) {
                                  return _vm.newShareEvent(true)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/images/publicFundsChange/share_white.png"),
                                  alt: ""
                                }
                              })
                            ]
                          )
                        ])
                      : _vm.isDetail
                      ? _c("div", {}, [
                          _c("div", [
                            _c(
                              "span",
                              {
                                style: {
                                  fontSize: _vm.changeCharSize
                                    ? "14px"
                                    : "inherit"
                                }
                              },
                              [_vm._v(_vm._s(_vm.finfoName))]
                            ),
                            _c("span", { staticClass: "stock-code" }, [
                              _vm._v(_vm._s(_vm.foundCode))
                            ])
                          ]),
                          _vm.isDetail
                            ? _c(
                                "div",
                                {
                                  staticClass: "share-news-scroll",
                                  on: {
                                    click: function($event) {
                                      return _vm.newShareEvent(false)
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/publicFundsChange/share_white.png"),
                                      alt: ""
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ]
            ],
            2
          ),
          _vm.$route.meta.showScreening
            ? _c(
                "div",
                {
                  staticClass: "screenIng",
                  on: {
                    click: function($event) {
                      _vm.showScreenIng = true
                    }
                  }
                },
                [
                  _c("span", { staticClass: "wordDes" }, [_vm._v("筛选")]),
                  _c("van-icon", {
                    staticClass: "screenIcon",
                    attrs: { name: "arrow-down" }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "rightOpera" }, [
            this.$route.meta.skipStep
              ? _c(
                  "div",
                  { staticClass: "skipStep" },
                  [
                    this.$route.meta.uploadIcon
                      ? _c("van-icon", {
                          staticClass: "quesMore",
                          attrs: { name: "question-o" },
                          on: { click: _vm.searchUploadPage }
                        })
                      : _vm._e(),
                    this.$route.meta.phone
                      ? _c("a", {
                          staticClass: "phoneIcon",
                          on: { click: _vm.callPhoneEvent }
                        })
                      : _vm._e(),
                    this.$route.meta.skipStep.stepName !== ""
                      ? _c(
                          "div",
                          {
                            staticClass: "distanceStyle",
                            on: { click: _vm.skipFunction }
                          },
                          [
                            _c("span", { staticClass: "wordDes" }, [
                              _vm._v("跳过")
                            ]),
                            _c("van-icon", {
                              staticClass: "screenIcon",
                              attrs: { name: "arrow" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.hideDetail
              ? _c(
                  "div",
                  {
                    staticClass: "skipStep searchDetail",
                    on: { click: _vm.searchPrivateDetail }
                  },
                  [_c("div", [_vm._v("详情")])]
                )
              : _vm._e(),
            this.$route.meta.showDetail
              ? _c(
                  "div",
                  {
                    staticClass: "skipStep searchDetail",
                    on: { click: _vm.searchPubDetail }
                  },
                  [_c("div", [_vm._v("详情")])]
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "rightOpera" }, [
            this.$route.meta.questionIcon
              ? _c(
                  "div",
                  { staticClass: "question", on: { click: _vm.goQuestion } },
                  [_vm._m(0)]
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "rightOpera" }, [
            this.$route.meta.sendEmail && _vm.fileList === "1"
              ? _c(
                  "div",
                  {
                    staticClass: "sendStyle",
                    on: {
                      click: function($event) {
                        _vm.showSureEmail = true
                      }
                    }
                  },
                  [_c("span", [_vm._v("发送到邮箱")])]
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "rightOpera phone" }, [
            this.$route.meta.showPhoneIcon
              ? _c(
                  "div",
                  {
                    staticClass: "callPhone",
                    on: {
                      click: function($event) {
                        return _vm.handlePhone(_vm.customerServicePhone)
                      }
                    }
                  },
                  [_vm._m(1)]
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "commonRight" }, [
            this.$route.meta.questionName
              ? _c(
                  "div",
                  {
                    staticClass: "iconItem",
                    on: { click: _vm.searchQuestion }
                  },
                  [_c("van-icon", { attrs: { name: "question-o" } })],
                  1
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "rightOpera" }, [
            this.$route.meta.oldValidate
              ? _c(
                  "div",
                  {
                    staticClass: "sendStyle alignClass",
                    on: { click: _vm.turnExample }
                  },
                  [_c("span", [_vm._v("查看示例")])]
                )
              : _vm._e()
          ])
        ]
      ),
      _c(
        "van-popup",
        {
          staticClass: "costomPopover",
          style: { top: _vm.dynamicTop },
          attrs: { position: "top" },
          model: {
            value: _vm.showScreenIng,
            callback: function($$v) {
              _vm.showScreenIng = $$v
            },
            expression: "showScreenIng"
          }
        },
        [
          _c("div", { staticClass: "tradingTime" }, [
            _c("div", { staticClass: "tradingTime__top" }, [
              _c("div", { staticClass: "tradingTitle" }, [_vm._v("交易时间")]),
              _c(
                "div",
                { staticClass: "tradingList" },
                [
                  _vm._l(_vm.timeArea, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "tradingItem",
                        class: { isClicked: item.flag },
                        on: {
                          click: function($event) {
                            return _vm.chooseItem(item, index)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(item.time) + " ")]
                    )
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "tradingItem",
                      class: { isClicked: _vm.startTimeClicked },
                      on: {
                        click: function($event) {
                          return _vm.clickStartTime("start")
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.startTime ? _vm.startTime : "起始时间") +
                          " "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "tradingItem",
                      class: { isClicked: _vm.endTimeClicked },
                      on: {
                        click: function($event) {
                          return _vm.clickStartTime("end")
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.endTime ? _vm.endTime : "结束时间") +
                          " "
                      )
                    ]
                  )
                ],
                2
              )
            ]),
            _c("div", { staticClass: "operaBtn" }, [
              _c(
                "div",
                {
                  staticClass: "btnNormal defaultBtn",
                  on: { click: _vm.resetState }
                },
                [_vm._v("重置")]
              ),
              _c(
                "div",
                {
                  staticClass: "btnNormal primaryBtn",
                  on: { click: _vm.confirmBtn }
                },
                [_vm._v("确定")]
              )
            ])
          ])
        ]
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showStartTimePicker,
            callback: function($$v) {
              _vm.showStartTimePicker = $$v
            },
            expression: "showStartTimePicker"
          }
        },
        [
          _c("van-datetime-picker", {
            attrs: {
              type: "date",
              title: _vm.timeTitle,
              "min-date": _vm.minDate,
              "max-date": _vm.maxDate
            },
            on: { confirm: _vm.getStartTime },
            model: {
              value: _vm.currentDate,
              callback: function($$v) {
                _vm.currentDate = $$v
              },
              expression: "currentDate"
            }
          })
        ],
        1
      ),
      _c(
        "van-dialog",
        {
          staticClass: "wrapperMod",
          attrs: { showConfirmButton: "" },
          on: {
            confirm: function($event) {
              _vm.showDialog = false
            }
          },
          model: {
            value: _vm.showDialog,
            callback: function($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog"
          }
        },
        [
          _c("div", { staticClass: "wrapper1" }, [
            _c("div", { staticClass: "top" }, [
              _vm._v(
                " 本人确认上述信息真实、准确和完整，且当这些信息发生变更时将在30日内通知贵机构 "
              )
            ]),
            _c("div", { staticClass: "center" }, [
              _vm._v(
                " 中国税收居民：是指在中国境内有住所，或者无住所而一个纳税年度内在中国境内居住累计满183天的个人。在中国境内有住所是指因户籍、家庭、经济利益关系而在中国境内习惯性居住。所谓习惯性居住，是判定纳税人义务人是居民或非居民的一个法律意义上的标准，不是指实际居住或在某一个特定时期内的居住地。 "
              )
            ]),
            _c("div", { staticClass: "bottom" }, [
              _vm._v(
                " 非居民：是指中国税收居民以外的个人。其他国家（地区）税收居民身份认定规则及纳税人识别号相关信息请参见国家税务总局网站。（http://www.chinatax.gov.cn/aeoi_index.html）。 "
              )
            ])
          ])
        ]
      ),
      _c(
        "van-dialog",
        {
          staticClass: "commonTip",
          attrs: {
            "show-confirm-button": _vm.booleanVal,
            "show-cancel-button": _vm.booleanVal
          },
          model: {
            value: _vm.showSureEmail,
            callback: function($$v) {
              _vm.showSureEmail = $$v
            },
            expression: "showSureEmail"
          }
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("请确认您的邮箱地址")]),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c("van-field", {
                staticClass: "customInput",
                attrs: { formatter: _vm.formatteEntip },
                model: {
                  value: _vm.customEmial,
                  callback: function($$v) {
                    _vm.customEmial = $$v
                  },
                  expression: "customEmial"
                }
              }),
              _c("div", {
                staticClass: "errorTip",
                domProps: { textContent: _vm._s(_vm.dynamicTips) }
              })
            ],
            1
          ),
          _c("div", { staticClass: "footer" }, [
            _c(
              "div",
              {
                staticClass: "commonS cancelBtn",
                on: { click: _vm.cancelFun }
              },
              [_vm._v("取消")]
            ),
            _c(
              "div",
              {
                staticClass: "commonS confirmBtn",
                on: { click: _vm.sendEmailFun }
              },
              [_vm._v("确认并发送")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "questionIcon" }, [
      _c("img", {
        attrs: {
          src: require("../assets/images/evaluation/questionIcon.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "callPhoneIcon" }, [
      _c("img", {
        attrs: { src: require("../assets/images/header/phone.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }